
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CodeCoverageTableCell',
  props: {
    isPassing: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      default: ''
    },
    repoName: {
      type: String,
      required: true
    },
    linkedCell: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parsedValue(): string {
      return `${this.value}%`
    }
  }
})
